<div class="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-gray-100 font-sans">

    <div class="relative hidden md:block">
        <img src="assets/images/scheduledmaintaince.png" alt="Maintenance"
            class="absolute inset-0 w-full h-full object-cover object-center" />


    </div>


    <div
        class="flex flex-col items-center justify-center text-center px-6 py-16 md:px-16 bg-white z-20 rounded-lg shadow-xl animate-fade-in space-y-6">
        <h1 class="text-4xl md:text-5xl font-extrabold text-[#112257] leading-tight">
            🚧 Scheduled Maintenance
        </h1>
        <p class="text-gray-600 max-w-xl text-lg md:text-xl">
            Edozzier is currently undergoing scheduled maintenance to serve you better. We appreciate your patience and
            will be back online shortly.
        </p>
        <a href="https://edozzier.com" target="_blank"
            class="mt-4 inline-block bg-[#112257] text-white px-8 py-3 rounded-full text-base font-semibold hover:bg-[#0e1b47] transition-all duration-300 shadow-lg hover:scale-105">
            Learn More About Edozzier
        </a>
    </div>

</div>